import React, { Component } from 'react'
import { RELATED_HELPERS } from './helpers'
import LanguageProvider from '../LanguageProvider/LanguageProvider'
import RelatedSidebar from '../../components/RelatedSidebar/RelatedSidebar'
import { connect } from 'react-redux'
import { createEvent } from '../UserEvents/actions'
import { fetchRelated, fetchInlineRelated, fetchSwimlane } from './actions'
import { selectData, selectIsFetching } from '../RelatedSidebar/selectors'
import { selectCurrentPhoneId } from '../App/selectors'

class RelatedSidebarContainer extends Component {
  componentDidMount() {
    this.fetchData(this.props)
  }

  componentWillReceiveProps(nextProps) {
    const { id } = nextProps

    if (id && this.props.id !== id) {
      this.fetchData(nextProps)
    }
  }

  fetchData(props) {
    const {
      id,
      contentType,
      phoneId,
      relatedType,
      fetchRelated,
      fetchSuggested,
      fetchSwimlane
    } = props

    switch (relatedType) {
      case 'suggested': {
        if (!id) {
          return
        }
        return fetchSuggested(id, contentType, phoneId)
      }
      case 'swimlane': {
        return fetchSwimlane()
      }
      default: {
        if (!id) {
          return
        }
        return fetchRelated(id, contentType, phoneId)
      }
    }
  }

  render() {
    const {
      relatedData,
      relatedType,
      isFetching,
      language,
      query,
      createUserEvent,
      contentType
    } = this.props
    const data = RELATED_HELPERS[relatedType](relatedData, isFetching, language)

    return (
      <RelatedSidebar
        data={data}
        query={query}
        createUserEvent={createUserEvent}
        relatedType={relatedType}
        isFetching={isFetching}
        contentType={contentType}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  query: state.routing.locationBeforeTransitions.query,
  relatedData: selectData(state, ownProps),
  isFetching: selectIsFetching(state, ownProps),
  phoneId: selectCurrentPhoneId(state)
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event)),
  fetchSuggested: (id, type, phoneId) =>
    dispatch(fetchInlineRelated.request(id, type, phoneId)),
  fetchRelated: (id, type, phoneId) =>
    dispatch(fetchRelated.request(id, type, phoneId)),
  fetchSwimlane: () => dispatch(fetchSwimlane.request())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageProvider(RelatedSidebarContainer))



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/RelatedSidebar.js